import React, { useState } from "react";

export default function Tooltip({ children, content, position = "top", tabIndex = 0, open = false }) {
  const [hovered, setHovered] = useState(false);
  const visible = open || hovered;

  return (
    <div
      className={`tooltip-wrapper${visible ? " is-open" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      tabIndex={tabIndex}
    >
      {children}
      {visible && (
        <div className={`tooltip-box tooltip-${position}`}>
          {content}
        </div>
      )}
    </div>
  );
}
